module.exports = __webpack_public_path__ + "static/media/faq_ling.bb3d0698.gif";